// Bootstrap
import 'bootstrap';

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.css';

// Custom SCSS
import '../scss/index.scss';
import { App } from './App';

new App().init();

